import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Download, Crosshair, Timer, ShieldCheck } from 'lucide-react';
export function ProcessSection() {
  const steps = [{
    icon: <Download className="w-8 h-8 text-brand-orange" data-id="element-150" />,
    title: 'Descarga y Lee',
    desc: 'Descarga el PDF y lee los primeros 2 capítulos (te tomará menos de 15 minutos).'
  }, {
    icon: <Crosshair className="w-8 h-8 text-brand-orange" data-id="element-151" />,
    title: 'Elige tu Objetivo',
    desc: 'Elige la tarea que más te aterra de tu lista actual.'
  }, {
    icon: <Timer className="w-8 h-8 text-brand-orange" data-id="element-152" />,
    title: 'Aplica el Ritual',
    desc: 'Aplica el Ritual 2-2-6 y observa cómo la resistencia desaparece antes de que suene el temporizador.'
  }];
  return <section className="py-24 relative" data-id="element-153">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-154">
        <FadeIn data-id="element-155">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-16" data-id="element-156">
            Cómo Funciona
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24 relative" data-id="element-157">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-gradient-to-r from-transparent via-brand-orange/30 to-transparent" data-id="element-158" />

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-159">
              <div className="flex flex-col items-center text-center" data-id="element-160">
                <div className="w-24 h-24 rounded-full bg-brand-card border-2 border-brand-orange/30 flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(249,115,22,0.15)] relative" data-id="element-161">
                  <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-brand-orange text-white font-bold flex items-center justify-center border-4 border-brand-dark" data-id="element-162">
                    {index + 1}
                  </div>
                  {step.icon}
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-163">
                  {step.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-164">{step.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-165">
          <div className="bg-gradient-to-br from-brand-orange/20 to-brand-orange/5 border border-brand-orange/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-166">
            <ShieldCheck className="w-16 h-16 text-brand-orange mx-auto mb-6 opacity-80" data-id="element-167" />
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-168">
              Nuestra Garantía de Acción
            </h3>
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto" data-id="element-169">
              En los primeros 7 días de uso, notarás que el "momento de
              arranque" deja de ser una batalla angustiante. No prometemos que
              amarás todas tus tareas, pero garantizamos que habrás dado el
              primer paso antes de que el cronómetro marque el minuto diez.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}